import { render } from "./DesignTerminal.vue?vue&type=template&id=599ca560&scoped=true"
import script from "./DesignTerminal.vue?vue&type=script&lang=js"
export * from "./DesignTerminal.vue?vue&type=script&lang=js"

import "./DesignTerminal.vue?vue&type=style&index=0&id=599ca560&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599ca560"]])

export default __exports__